import React, { useEffect, createElement } from 'react';
const SEO_CONFIG = {
  title: 'TTVIP - 新加坡顶级伴游平台 | 十年高端伴游服务品牌 | Singapore Premier Companion',
  description: 'TTVIP新加坡顶级伴游平台，创立于2014年，十年专注高端伴游服务。严格甄选500+全球优质佳丽，汇聚日韩、欧美、越南、中国等多国美女资源。提供商务伴游、旅行伴游、私人派对、定制服务等专业伴游体验。真实照片验证、隐私端到端加密、24小时专属管家服务。新加坡最受信赖的高端伴游品牌，99%客户好评率，50000+尊贵客户的共同选择。TTVIP - Singapore premier companion platform since 2014, 500+ elite companions from Japan, Korea, Europe, Vietnam and China. Business escort, travel companion, private events. Verified photos, absolute privacy, 24/7 concierge.',
  keywords: 'TTVIP,新加坡伴游,新加坡顶级伴游,新加坡高端伴游,新加坡伴游平台,新加坡伴游网站,新加坡伴游服务,新加坡美女伴游,新加坡商务伴游,新加坡旅行伴游,新加坡私人伴游,新加坡定制伴游,Singapore escort,Singapore companion,Singapore escort service,新加坡芽笼,geylang,新加坡外围,新加坡高端外围,新加坡陪游服务,新加坡上门服务,新加坡SPA,新加坡按摩,新加坡夜生活,日韩佳丽,日本伴游,韩国伴游,欧美名媛,越南风情,中华丽人,新加坡约会,新加坡小姐,SG Escort,Singapore Escorts,Singapore call girl,singapore massage,新加坡红灯区,新加坡桑拿,新加坡酒店上门,新加坡模特,geylang666,geylang777,新加坡金沙网,新加坡倾城网,新加坡千金网,sgvipclubs,sgbeautycastle,新加坡狼友,新加坡后宫网,sgharem,sgwolf,新加坡kkbaby,新加坡男士spa,新加坡24小时spa,新加坡全套服务,新加坡一条龙服务,新加坡包夜服务,新加坡OUTCALL,新加坡INCALL,新加坡伴游推荐,新加坡最好伴游,新加坡正规伴游,新加坡安全伴游,新加坡真实伴游,新加坡伴游价格,新加坡伴游预约,ttvip伴游,ttvip新加坡',
  url: 'https://www.geylang777-6.site',
  image: 'https://www.geylang777-6.site/og-image.jpg'
};
function setMeta(name: string, content: string, property?: boolean) {
  const attr = property ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function SEO() {
  useEffect(() => {
    // Title
    document.title = SEO_CONFIG.title;
    // Basic Meta
    setMeta('description', SEO_CONFIG.description);
    setMeta('keywords', SEO_CONFIG.keywords);
    setMeta('author', 'TTVIP Singapore');
    setMeta('robots', 'index, follow');
    setMeta('language', 'zh-CN');
    // Open Graph
    setMeta('og:title', SEO_CONFIG.title, true);
    setMeta('og:description', SEO_CONFIG.description, true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', SEO_CONFIG.url, true);
    setMeta('og:image', SEO_CONFIG.image, true);
    setMeta('og:site_name', 'TTVIP - 新加坡顶级伴游', true);
    setMeta('og:locale', 'zh_CN', true);
    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', SEO_CONFIG.title);
    setMeta('twitter:description', SEO_CONFIG.description);
    setMeta('twitter:image', SEO_CONFIG.image);
    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', SEO_CONFIG.url);
    // Language
    document.documentElement.setAttribute('lang', 'zh-CN');
    // JSON-LD Structured Data
    let jsonLd = document.querySelector('script[type="application/ld+json"]') as HTMLScriptElement | null;
    if (!jsonLd) {
      jsonLd = document.createElement('script');
      jsonLd.setAttribute('type', 'application/ld+json');
      document.head.appendChild(jsonLd);
    }
    jsonLd.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'TTVIP',
      alternateName: 'TTVIP新加坡顶级伴游平台',
      url: SEO_CONFIG.url,
      logo: SEO_CONFIG.image,
      description: 'TTVIP新加坡顶级伴游平台，创立于2014年，十年专注高端伴游服务，汇聚全球500+优质佳丽，提供商务伴游、旅行伴游、私人派对等专业服务。',
      foundingDate: '2014',
      areaServed: {
        '@type': 'Country',
        name: 'Singapore'
      },
      sameAs: ['https://t.me/gl777net'],
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '50000',
        bestRating: '5'
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'TTVIP伴游服务',
        itemListElement: [{
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '商务伴游 Business Companion'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '旅行伴游 Travel Companion'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '私人派对 Private Events'
          }
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '定制服务 Custom Experience'
          }
        }]
      }
    });
  }, []);
  return null;
}